import { useSend } from '../../useApi';

// PATCH /admin/feedback/{id}: status and an internal note.
const useUpdateFeedback = () => {
  const { loading, send } = useSend('Could not update the feedback');
  return {
    saving: loading,
    update: (id: string, body: { status?: string; note?: string }, onDone?: () => void) =>
      send({ url: `api/v1/admin/feedback/${id}`, method: 'patch', data: body }, () => onDone?.()),
  };
};

export default useUpdateFeedback;
